<template>
  <div class="loading-container" v-if="selectedValue">
    <div class="loading-animation"></div>
  </div>
</template>
<script>
export default {
  name: 'XrLoading',
  props: ['isLoading'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      selectedValue: false
    }
  },
  watch: {
    isLoading(newValue) {
      this.selectedValue = newValue;
    }
  },
}
</script>

<style lang="scss" scoped>
  /** 加载中动画 */
  .loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1000;
  }

  .loading-animation {
    width: 50px;
    height: 50px;
    border: 6px solid #f3f3f3;
    border-top: 6px solid #3498db;
    border-radius: 50%;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/XrLoading/index.vue